import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-paragraph',
  imports: [NgStyle],
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss'],
})
export class ParagraphComponent {
  @Input('font-size') fontSize?: 'default' | 'small' | 'large' = 'default';
  @Input('max-width') maxWidth?: number;
}
